export class TransporterImportModel {
    counter: number = 0;
    branchCode: number = 0;
    name: string = '';
    typeDocumentId: number = 0;
    documents: string = '';
    digitVerification: number = 0;
    phone: string = '';
    alterPhone: string | null = null;
    active: boolean = false;
    swExternal: boolean = false;

    constructor(
        counter: number,
        branchCode: number,
        name: string,
        typeDocumentId: number,
        documents: string,
        digitVerification: number,
        phone: string,
        alterPhone: string | null,
        active: boolean,
        swExternal: boolean
    ) {
        this.counter = counter;
        this.branchCode = branchCode;
        this.name = name;
        this.typeDocumentId = typeDocumentId;
        this.documents = documents;
        this.digitVerification = digitVerification;
        this.phone = phone;
        this.alterPhone = alterPhone;
        this.active = active;
        this.swExternal = swExternal;
    }
}
